import SectionHeading from "./SectionHeading";

const beliefs = [
  {
    n: "01",
    title: "Humans and AI agents will build software together.",
    text: "Most teams will soon have both on the same backlog. We design for that.",
  },
  {
    n: "02",
    title: "Tools should coordinate people and agents, not replace them.",
    text: "Clear ownership, clear handoffs, and a record of who did what.",
  },
  {
    n: "03",
    title: "Privacy-first by default.",
    text: "Your code and your backlog stay yours. Collect less, expose nothing by accident.",
  },
  {
    n: "04",
    title: "We use what we build every day.",
    text: "Every product runs our own work before anyone else sees it.",
  },
];

const BeliefsSection = () => (
  <section
    id="beliefs"
    className="mx-auto max-w-[1200px] scroll-mt-[68px] px-[clamp(16px,5vw,48px)] pt-[clamp(80px,10vw,140px)]"
  >
    <SectionHeading index="01" label="Principles">
      What we believe
    </SectionHeading>
    <div className="mt-12 grid grid-cols-[repeat(auto-fit,minmax(min(100%,250px),1fr))] gap-4">
      {beliefs.map((b) => (
        <article
          key={b.n}
          className="flex flex-col rounded-2xl border border-border bg-card p-7 transition-[border-color,box-shadow] duration-200 hover:border-primary-light hover:shadow-primary"
        >
          <div className="font-mono text-[13px] text-accent-text">{b.n}</div>
          <h3 className="text-balance mt-10 text-[21px] font-semibold leading-[1.3] tracking-[-0.015em]">{b.title}</h3>
          <p className="text-pretty mt-3 text-[15px] leading-[1.6] text-muted-foreground">{b.text}</p>
        </article>
      ))}
    </div>
  </section>
);

export default BeliefsSection;
